export const CashOffLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler  icon-tabler-cash-banknote-off" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405" />
            <path d="M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1" />
            <line x1="18" y1="12" x2="18.01" y2="12" />
            <line x1="6" y1="12" x2="6.01" y2="12" />
            <line x1="3" y1="3" x2="21" y2="21" />
        </svg>
    )
}

export const LogoHome = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler  icon-tabler-cash-banknote-off" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405" />
            <path d="M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1" />
            <line x1="18" y1="12" x2="18.01" y2="12" />
            <line x1="6" y1="12" x2="6.01" y2="12" />
            <line x1="3" y1="3" x2="21" y2="21" />
        </svg>
    )
}

export const BuildingWarehouseLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-building-warehouse" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M3 21v-13l9 -4l9 4v13" />
            <path d="M13 13h4v8h-10v-6h6" />
            <path d="M13 21v-9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v3" />
        </svg>
    )
}

export const RevisionProveedores = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6"
        {...props}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
    )
}
export const RecepcionIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6"
        {...props}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75" />
        </svg>
    )
}

export const CircleDashedLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-dashed" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M8.56 3.69a9 9 0 0 0 -2.92 1.95" />
            <path d="M3.69 8.56a9 9 0 0 0 -.69 3.44" />
            <path d="M3.69 15.44a9 9 0 0 0 1.95 2.92" />
            <path d="M8.56 20.31a9 9 0 0 0 3.44 .69" />
            <path d="M15.44 20.31a9 9 0 0 0 2.92 -1.95" />
            <path d="M20.31 15.44a9 9 0 0 0 .69 -3.44" />
            <path d="M20.31 8.56a9 9 0 0 0 -1.95 -2.92" />
            <path d="M15.44 3.69a9 9 0 0 0 -3.44 -.69" />
        </svg>
    )
}

export const FileExportLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-file-export" width="44" height="44" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3" />
        </svg>
    )
}
export const FacturaQuetzal = (props) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-file-export" width="44" height="44" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
      >
          <path className="cls-1" d="M15.75,12.75v-2.62c0-1.86-1.51-3.38-3.38-3.38h-1.5c-.62,0-1.12-.5-1.12-1.12h0v-1.5c0-1.86-1.51-3.38-3.38-3.38h-1.88m2.26,0H1.88C1.25,.75,.75,1.25,.75,1.88V19.12c0,.62,.5,1.12,1.12,1.12H14.62c.62,0,1.12-.5,1.12-1.12V9.75c.01-4.97-4.02-9-8.99-9Z"/>
          <path d="M7.89,16.29c-.25,0-.5-.02-.76-.07s-.51-.12-.75-.22-.47-.22-.69-.37-.42-.32-.6-.51c-.71-.78-1.07-1.8-1.07-3.06,0-1.36,.36-2.43,1.09-3.23,.73-.8,1.74-1.21,3.01-1.21,1.14,0,2.07,.39,2.78,1.17s1.07,1.8,1.07,3.06c0,.53-.06,1.03-.18,1.5s-.3,.9-.54,1.27-.55,.7-.91,.96-.8,.45-1.3,.57c.2,.22,.39,.41,.57,.58s.36,.31,.53,.42,.36,.2,.55,.26,.4,.09,.63,.09h.21c.08,0,.15-.02,.23-.03s.15-.03,.22-.05,.13-.04,.19-.06v.95c-.06,.02-.13,.04-.21,.05s-.16,.03-.24,.04-.16,.02-.24,.02h-.22c-.38,0-.71-.06-1.01-.17s-.58-.26-.84-.46c-.26-.19-.51-.42-.75-.68s-.5-.54-.76-.83h0Zm.13-7.78c-.88,0-1.6,.32-2.15,.96s-.83,1.47-.83,2.51,.27,1.87,.8,2.5c.54,.63,1.24,.94,2.1,.94,.92,0,1.65-.3,2.18-.9s.8-1.44,.8-2.53-.26-1.97-.77-2.57c-.52-.61-1.23-.91-2.13-.91Z"/>
      </svg>
    )
}

export const ForkLiftLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-forklift" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <circle cx="5" cy="17" r="2" />
            <circle cx="14" cy="17" r="2" />
            <line x1="7" y1="17" x2="12" y2="17" />
            <path d="M3 17v-6h13v6" />
            <path d="M5 11v-4h4" />
            <path d="M9 11v-6h4l3 6" />
            <path d="M22 15h-3v-10" />
            <line x1="16" y1="13" x2="19" y2="13" />
        </svg>
    )
}

export const InvoiceLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-file-invoice" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
            <line x1="9" y1="7" x2="10" y2="7" />
            <line x1="9" y1="13" x2="15" y2="13" />
            <line x1="13" y1="17" x2="15" y2="17" />
        </svg>
    )
}

export const MathSymbolsLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-math-symbols" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="12" y1="3" x2="12" y2="21" />
            <line x1="16.5" y1="4.5" x2="19.5" y2="7.5" />
            <line x1="19.5" y1="4.5" x2="16.5" y2="7.5" />
            <line x1="6" y1="4" x2="6" y2="8" />
            <line x1="4" y1="6" x2="8" y2="6" />
            <line x1="18" y1="16" x2="18.01" y2="16" />
            <line x1="18" y1="20" x2="18.01" y2="20" />
            <line x1="4" y1="18" x2="8" y2="18" />
        </svg>
    )
}

export const ParkingLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-parking" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <rect x="4" y="4" width="16" height="16" rx="2" />
            <path d="M9 16v-8h4a2 2 0 0 1 0 4h-4" />
        </svg>
    )
}

export const ReportMoney = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-report-money" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
            <rect x="9" y="3" width="6" height="4" rx="2" />
            <path d="M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
            <path d="M12 17v1m0 -8v1" />
        </svg>
    )
}

export const ShoppingCartLogo = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-shopping-cart-plus" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
        {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <circle cx="6" cy="19" r="2" />
            <circle cx="17" cy="19" r="2" />
            <path d="M17 17h-11v-14h-2" />
            <path d="M6 5l6.005 .429m7.138 6.573l-.143 .998h-13" />
            <path d="M15 6h6m-3 -3v6" />
        </svg>
    )
}
